import apiClient from './apiClient';

export interface Coupon {
  id: string;
  code: string;
  title: string;
  description: string;
  discount: number;
  expiry: string;
}

export const fetchCoupons = async (): Promise<Coupon[]> => {
  const response = await apiClient.get('/coupon');
  // Support response shape: { data: { coupons: [...] } }
  if (response?.data?.data && Array.isArray(response.data.data.coupons)) {
    return response.data.data.coupons;
  }
  // Fallback for other shapes
  return response.data.data || response.data;
};
